import 'regenerator-runtime/runtime';
import { auth } from './Reducks/Auth/actions';

const getTokenFromServer = async () => {
  const urlParams = new URLSearchParams(window.location.search);
  const storage = window.sessionStorage;

  // No valid token, check for redirect from auth server
  const stateFromLocation = urlParams.get('state');
  if (stateFromLocation) {
    // SECURITY CHECK: Verify the 'state' parameter
    if (storage.getItem('pkce_state') !== stateFromLocation) {
      throw new Error('State parameter mismatch. Possible session hijacking attack!');
    }

    const authorizationCode = urlParams.get('code');
    if (!authorizationCode) {
      throw new Error('Authorization failed: No authorization code was returned.');
    }

    const initialCodeVerifier = storage.getItem('pkce_code_verifier');

    const configForAuth = {
      state: stateFromLocation,
      code: authorizationCode,
      code_verifier: initialCodeVerifier
    };

    try {
      const requestToken = await auth.requestPKCEToken(configForAuth);
      // Store the token with the path in state
      storage.setItem('endToEnd', JSON.stringify({ auth: requestToken }));

      // Clean up
      window.history.replaceState({}, document.title, window.location.pathname);
      storage.removeItem('pkce_state');
      storage.removeItem('pkce_code_verifier');
    } catch (e) {
      throw new Error('Authorization failed: Token request failed.');
    }
  } else {
    console.error('No Valid Token found');
  }
};

(async () => {
  await getTokenFromServer();
  const token = JSON.parse(window.sessionStorage.getItem('endToEnd'));
  const isValidToken = token && token.auth;
  if (isValidToken) {
    if (window.name === 'TokenRefreshWindow') {
      window.opener.resolveRefreshToken(JSON.stringify(token.auth));
      window.close();
    } else {
      const path = window.sessionStorage.getItem('pkce_path') || '/';
      window.location.href = path;
      window.sessionStorage.removeItem('pkce_path');
    }
  } else {
    if (window.name === 'TokenRefreshWindow') {
      window.close();
    }
    console.error('Invalid/expired auth token!', token);
  }
})();
